<script setup lang="ts">
import { ConfirmationContentData } from './types';
import IdentifierLabel from '@/components/IdentifierLabel/IdentifierLabel.vue';

defineProps<ConfirmationContentData>();
</script>

<template>
  <p v-if="confirmation" class="text-pre-line">
    {{ confirmation }}
  </p>

  <IdentifierLabel
    class="mt-4 mb-4"
    :label="entityData.name"
    :identifier="entityData.iuid"
  ></IdentifierLabel>

  <p v-if="hint" class="text-pre-line">
    {{ hint }}
  </p>
</template>
